module.exports = __webpack_public_path__ + "img/bongeste.e7318571.png";